module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processSelect),
      expression: "processSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.processSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 處理狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已處理")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未處理")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("時間")])])]), _vm._v(" "), (_vm.searchSelect == 1) ? _c('div', {
    staticClass: "form-group input-group time-box"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getAbnormalOrderList('search')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), (_vm.roleType === 99) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌(ID)")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店(ID)")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂購者"), (_vm.roleType === 99) ? _c('span', [_vm._v("(ID)")]) : _vm._e()]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("電話")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("總數")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("總額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("處理狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("下訂時間")])])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (_vm.orderList.length === 0) ? _c('tbody', [_vm._m(1)]) : (_vm.orderList.length > 0) ? _c('tbody', _vm._l((_vm.orderList), function(order, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/orderInfo/' + order.order_id
        },
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(order.order_sn))])], 1), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.orderStateColor(order.status)
    }, [_vm._v(_vm._s(_vm.orderState(order.status)))])]), _vm._v(" "), _c('td', [(order.order_type === 1) ? _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("一般單")]) : _vm._e(), _vm._v(" "), (order.order_type === 2) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("團購單")]) : _vm._e()]), _vm._v(" "), (_vm.roleType === 99) ? _c('td', [_vm._v(_vm._s(order.brand_name) + "(" + _vm._s(order.brand_id) + ")")]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('td', [_vm._v(_vm._s(order.store_name) + "(" + _vm._s(order.store_id) + ")")]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.roleType !== 99 || _vm.$route.name == 'memberOrderTable') ? _c('span', [_vm._v(_vm._s(order.name)), (_vm.roleType === 99) ? _c('span', [_vm._v("(" + _vm._s(order.shopper_id) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleType === 99 && _vm.$route.name !== 'memberOrderTable') ? _c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          path: '/memberOrderTable/' + order.shopper_id
        }
      }
    }, [_vm._v(_vm._s(order.name) + "(" + _vm._s(order.shopper_id) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('td', [_vm._v("＄" + _vm._s(order.money))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payStateName(order.payment_status)))]), _vm._v(" "), _c('td', [(order.is_processed) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("已處理")]) : _vm._e(), _vm._v(" "), (!order.is_processed) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未處理")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTime(order.order_time)))])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34b96bf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Order/Temp/OrderExceptionTableTemp.vue
// module id = 2380
// module chunks = 1